

import styled, { css } from "styled-components";



export const SiteHome = styled.div`
  /* background-color: gray; */
  padding: 20px;
`;

export const BallMove = styled.h1`
display: block;
text-align: center;
margin-top: 20px;
`;


export const LinesAnimation = styled.span`
  /* height: 86px; */
  margin-top: 150px;
  text-align: center;
  font: 700 4em/1 "Oswald", sans-serif;
  letter-spacing: 0;
  /* padding: 0.25em 0 0.325em; */
  display: block;
  text-shadow: 0 0 80px rgba(255, 255, 255, 0.5);
  /* Clip Background Image */
  background: url(https://i.ibb.co/RDTnNrT/animated-text-fill.png);
  -webkit-background-clip: text;
  background-clip: text;
  /* Animate Background Image */
  -webkit-text-fill-color: transparent;
  -webkit-animation: aitf 80s linear infinite;

  /* Activate hardware acceleration for smoother animations */
  /* -webkit-transform: translate3d(300, 100, 30); */
  /* -webkit-backface-visibility: hidden; */
`;


export default SiteHome;

